module.exports = __webpack_public_path__ + "static/media/calendar-times.2b351cf5.svg";